import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  searchModal: boolean;
};

const initialState: InitialState = {
  searchModal: false,
};

const searchModalSlice = createSlice({
  name: "searchModalSlice",
  initialState,
  reducers: {
    toggleSearchModal: (state, action: PayloadAction) => {
      state.searchModal = !state.searchModal;
      return state;
    },
    closeSearchModal: (state, action: PayloadAction) => {
      state.searchModal = false;
      return state;
    },
  },
});

export const { toggleSearchModal, closeSearchModal } = searchModalSlice.actions;
export default searchModalSlice;
